module.exports = __webpack_public_path__ + "img/GG.a90b1fdd.svg";